import { useState } from "react"
import { faCamera } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import UploadPhotoModal from "@/components/UploadPhotoModal"
import Modal from "@/components/modal"
import Link from "@/components/link"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import env from "@/env"
import physicalRiskStore from "../../model/physical-risk.store"

export default function PhysicalRiskPhotoPanel({
  isReadonly,
  isTopAligned
}: {
  isReadonly?: boolean
  isTopAligned?: boolean
}) {
  const dispatch = useAppDispatch()
  const risk = useAppSelector(physicalRiskStore.selectors.draft)
  const [modal, setModal] = useState<"MODAL_UPLOAD_PHOTO" | "MODAL_DISPLAY_PHOTO" | null>(null)

  async function handleUpload(id: string) {
    await dispatch(physicalRiskStore.thunks.updatePhoto(id))
    setModal(null)
  }

  return (
    <div className="mb-20 flex min-h-0 flex-1 flex-col">
      <div className="text-input-title flex" style={isTopAligned ? { marginTop: 0 } : undefined}>
        <span className="grey-t">Photo du risque</span>
      </div>
      {/* Padding (et non marge) de 4px : aligne le cadre sur les inputs sans fusionner avec la marge du label */}
      <div className="flex min-h-0 flex-1 py-[4px]">
        {/* Pas de hauteur propre : le cadre s'etire sur la place restante (align-items stretch), plafonne
            a 162px pour rester carre au maximum, avec un plancher pour garder le libelle lisible */}
        <div
          className={`${risk.photoId || !isReadonly ? "_hover" : ""} ${isReadonly ? "h-[162px]" : ""} box-border flex max-h-[162px] min-h-[70px] w-full bg-slate-100`}
          style={{ border: "1px dashed #CBD5E1", borderRadius: 12 }}
          onClick={(event) => {
            if (isReadonly) event.stopPropagation()
            if (risk.photoId) setModal("MODAL_DISPLAY_PHOTO")
            else if (!isReadonly) setModal("MODAL_UPLOAD_PHOTO")
          }}>
          {modal === "MODAL_UPLOAD_PHOTO" && (
            <UploadPhotoModal onClose={() => setModal(null)} onUpload={(id) => handleUpload(id)} />
          )}

          {modal === "MODAL_DISPLAY_PHOTO" && (
            <Modal isLarge onClose={() => setModal(null)} isCloseButtonVisible title={risk.cName}>
              <>
                {!isReadonly && (
                  <>
                    <Link isWithoutMargin onClick={() => setModal("MODAL_UPLOAD_PHOTO")}>
                      Modifier / supprimer la photographie
                    </Link>
                    <div className="h-20" />
                  </>
                )}
              </>
              {risk.photoId && (
                <div className="flex justify-center">
                  <img
                    alt={risk.photoId}
                    className="max-h-[70vh] max-w-full rounded-[12px] object-contain"
                    src={env.REACT_APP_URL_SPACE.concat("/Photos/", risk.photoId, ".png")}
                  />
                </div>
              )}
              <div className="h-20" />
            </Modal>
          )}

          {risk.photoId ? (
            <img
              alt={risk.photoId}
              className="h-full w-full rounded-[12px] object-cover"
              src={env.REACT_APP_URL_SPACE.concat("/Photos/", risk.photoId, ".png")}
            />
          ) : (
            <div className="flex flex-1 flex-col items-center justify-center gap-[8px] px-[8px] text-center grey-t">
              <FontAwesomeIcon icon={faCamera} className="text-2xl text-slate-300" />
              <span className="text-sm">Uploader une photo</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
